import React from "react";
import { Tooltip } from "@mui/material";
import { getArtworkStatusInfo, ArtworkStatusColor } from "../../functions/ArtworkStatus";

// Maps status "color" keys to actual CSS colors for the badge background/icon.
const COLOR_MAP: Record<ArtworkStatusColor, { bg: string; fg: string }> = {
    success: { bg: "#e6f4ea", fg: "#1e7e34" },
    warning: { bg: "#fff4e0", fg: "#b06a00" },
    default: { bg: "#eceff1", fg: "#455a64" },
    info: { bg: "#e3f2fd", fg: "#1565c0" },
    secondary: { bg: "#f2e7fe", fg: "#6a1b9a" },
    error: { bg: "#fdecea", fg: "#c62828" },
};

type ArtworkStatusBadgeProps = {
    statusId: number | null | undefined;
    size?: number;
    // true (default): absolutely positioned over an image (card/gallery thumbnail).
    // false: static, inline sizing — for use in table cells, lists, etc.
    overlay?: boolean;
};

// Small circular icon badge indicating an artwork's current status.
// By default it's layered on top of the artwork thumbnail (see .catalogue-status-badge in App.css).
// Pass overlay={false} to render it inline instead (e.g. inside a table cell).
const ArtworkStatusBadge: React.FC<ArtworkStatusBadgeProps> = ({ statusId, size = 24, overlay = true }) => {
    const status = getArtworkStatusInfo(statusId);
    if (!status) return null;
    const { bg, fg } = COLOR_MAP[status.color];
    const Icon = status.icon;
    return (
        <Tooltip title={status.name} arrow>
            <div
                className={overlay ? "catalogue-status-badge" : "catalogue-status-badge catalogue-status-badge--inline"}
                style={{
                    width: size,
                    height: size,
                    backgroundColor: bg,
                    color: fg,
                    flexShrink: 0,
                }}
            >
                <Icon style={{ fontSize: size * 0.62 }} />
            </div>
        </Tooltip>
    );
};

export default ArtworkStatusBadge;
